import {CUSTOMER_DETAILS_SERVICE_NAME} from "../../../utils/names/serviceNames";
import './editable-field.component.scss';
import {
    ICompileService,
    IComponentController,
    IComponentOptions,
    IControllerConstructor,
    Injectable,
    IScope
} from "angular";
import {CustomerDetailsService} from "../../../customer_service/service/CustomerDetailService";
import {Customer} from "../../../customers/model/Customer";
import {CustomerInfoOptions} from "../../model/CustomerInfoOptions";
import {Partner} from "../../../partner/model/Partner";
import {Lead} from "../../../lead/model/Lead";

export function getEditableFieldConfiguration(template: string,
                                              controller: Injectable<IControllerConstructor>,
                                              bindgins = {}): IComponentOptions {
    return {
        template: template,
        controller: controller,
        bindings: Object.assign(bindgins, {
            "fieldName": "@",
            "customer": "<",
            "isRequired": "<",
            "options": "<",
            "inputValue": "=",
            "pattern": "@",
            "errorMessage": "@"
        })
    }
}

export class EditableFieldComponent implements IComponentController {

    static controller = ['$scope', '$route', '$compile', CUSTOMER_DETAILS_SERVICE_NAME, EditableFieldComponent];

    static directive: angular.IDirectiveFactory = () => ({
        template: require('./editable-field.component.html'),
        restrict: 'E',
        controller: EditableFieldComponent.controller,
        transclude: {
            displayField: '?displayField',
            editField: '?editField'
        },
        scope: {
            "errorMessage": "<",
            "customer": "<",
            "inputValue": "=",
            "options": "<"
        },
        controllerAs: '$ctrl',
        bindToController: true
    });

    private errorMessage: string;
    private customer: Customer | Lead | Partner;
    private inputValue: any;
    private options: CustomerInfoOptions;

    private showEditFields: boolean;
    private lastValue: any;

    constructor(private $scope: IScope,
                private $route: ng.route.IRouteService,
                private $compile: ICompileService,
                private customerDetailsService: CustomerDetailsService) {
        this.showEditFields = false;
    }

    $onInit = () => {

        this.lastValue = this.inputValue;
        this.options = this.options || {
            readonly: false
        }
    };

    save = () => {
        this.showEditFields = false;
        this.updateContact();
    };

    cancelEditing = () => {
        this.inputValue = this.lastValue;
        this.showEditFields = false;
    };


    updateContact = () => {
        this.customerDetailsService.updateContact(this.customer);
    };


    editText = ($event: MouseEvent) => {
        this.lastValue = this.inputValue;
        if (!this.options.readonly) {
            this.showEditFields = true;
        }
    };


}